import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from '@repo/analytics/analytics-provider';
import { Button } from '@repo/design-system/components/ds/button';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { TextArea } from '@repo/design-system/components/ui/text-area';
import { toast } from '@repo/design-system/components/ui/toaster';
import { Type } from '@repo/design-system/components/ui/type';
import { useHostType } from '@repo/host/hooks/use-host-info';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectCurrentMapInfo, selectMapConfig, selectSelectedMarkerId } from '@repo/store/maps/slices/mapData';
import { createMapEmbedCode } from '@repo/types/maps/map-utils';
import { copyTextToClipboard } from '@repo/utility/clipboard';
import { useMemo, useState } from 'react';
export const MapEmbedContent = () => {
  const $ = _c(31);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const mapConfig = useAppSelector(selectMapConfig);
  const currentMapInfo = useAppSelector(selectCurrentMapInfo);
  const selectedMarkerId = useAppSelector(selectSelectedMarkerId);
  const [copied, setCopied] = useState(false);
  const hostType = useHostType();
  const analytics = useAnalytics();
  mapConfig?.titleSlug;
  currentMapInfo?.slug;
  let t1;
  bb0: {
    if (!mapConfig?.titleSlug || !currentMapInfo?.slug) {
      t1 = "";
      break bb0;
    }
    const t2 = mapConfig?.titleSlug;
    const t3 = currentMapInfo?.slug;
    const t4 = selectedMarkerId ?? undefined;
    let t5;
    if ($[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
      t5 = createMapEmbedCode({
        titleSlug: t2,
        mapSlug: t3,
        locationId: t4
      });
      $[1] = t2;
      $[2] = t3;
      $[3] = t4;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    t1 = t5;
  }
  const getEmbedCode = t1;
  let t2;
  if ($[5] !== analytics || $[6] !== currentMapInfo || $[7] !== getEmbedCode || $[8] !== hostType || $[9] !== t) {
    t2 = async () => {
      const result = await copyTextToClipboard(getEmbedCode);
      if (result.success) {
        setCopied(true);
        toast({
          description: t(_temp),
          variant: "success"
        });
        setTimeout(() => {
          setCopied(false);
        }, 2000);
        if (analytics && currentMapInfo?.externalId && hostType) {
          analytics.event("game_map_embed_copy_code", {
            mapId: currentMapInfo.externalId,
            platform: hostType
          });
        }
      } else {
        toast({
          description: t(_temp2),
          variant: "error"
        });
      }
    };
    $[5] = analytics;
    $[6] = currentMapInfo;
    $[7] = getEmbedCode;
    $[8] = hostType;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const copyEmbedCode = t2;
  let t3;
  if ($[11] !== t) {
    t3 = t(_temp3);
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== t3) {
    t4 = <Type variant="body-s" color="text.primary">{t3}</Type>;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t) {
    t5 = t(_temp4);
    $[15] = t;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = css({
      color: "white",
      _disabled: {
        opacity: "1"
      }
    });
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== getEmbedCode || $[19] !== t5) {
    t7 = <TextArea size="sm" disabled={true} fullWidth={true} value={getEmbedCode} placeholder={t5} className={t6} rows={8} />;
    $[18] = getEmbedCode;
    $[19] = t5;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== copied || $[22] !== t) {
    t8 = copied ? t(_temp5) : t(_temp6);
    $[21] = copied;
    $[22] = t;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== copyEmbedCode || $[25] !== t8) {
    t9 = <Button onClick={copyEmbedCode} color="white" size="lg" fullWidth={true}>{t8}</Button>;
    $[24] = copyEmbedCode;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t4 || $[28] !== t7 || $[29] !== t9) {
    t10 = <FlexColumn height="full" gap="12">{t4}{t7}{t9}</FlexColumn>;
    $[27] = t4;
    $[28] = t7;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
};
function _temp($) {
  return $.game_map_embed.copied_toast;
}
function _temp2($_0) {
  return $_0.game_map_embed.copy_error;
}
function _temp3($_1) {
  return $_1.game_map_embed.embed_map_description;
}
function _temp4($_2) {
  return $_2.embed_code;
}
function _temp5($_3) {
  return $_3.game_map_embed.copied;
}
function _temp6($_4) {
  return $_4.game_map_embed.copy_code;
}